import { useMemo } from 'react';
import { useRect } from './useRect.mjs';
import { useWindowSizeOf } from './useWindowSizeOf.mjs';
import { findFirstScrollableChild } from '../utilities/scroll.mjs';
import { useScrollSize } from '../../../hooks/useScrollSize/useScrollSize.mjs';
import { useScrollHint } from '../../../hooks/useScrollHint/useScrollHint.mjs';

function useMeasurements({
  anchor,
  popover
}) {
  const scrollElement = useMemo(() => findFirstScrollableChild(popover), [popover]);

  // TODO: Add update on scroll params to update anchor y and x position
  const anchorRect = useRect(anchor);
  const popoverRect = useRect(popover);
  const {
    innerWidth,
    innerHeight
  } = useWindowSizeOf(popover);
  const containerSize = {
    width: innerWidth,
    height: innerHeight
  };
  const scrollSize = useScrollSize(scrollElement);
  useScrollHint(scrollElement);
  return {
    anchorRect,
    popoverSize: {
      width: popoverRect === null || popoverRect === void 0 ? void 0 : popoverRect.width,
      height: popoverRect === null || popoverRect === void 0 ? void 0 : popoverRect.height
    },
    containerSize,
    scrollSize
  };
}

export { useMeasurements };
